import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { getPost } from '../services/blogService';
import './BlogPostPage.css';

function formatDate(ts) {
  if (!ts) return '';
  const d = ts.toDate ? ts.toDate() : new Date(ts.seconds * 1000);
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export default function BlogPostPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    getPost(slug).then((p) => {
      if (!p || !p.published) setNotFound(true);
      else setPost(p);
    }).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="blog-post-page">
        <nav className="blog-nav">
          <button className="blog-nav-back" onClick={() => navigate('/blog')}>← Blog</button>
          <span className="blog-nav-logo display-font">World Cup Pick'em</span>
        </nav>
        <div className="blog-post-content blog-not-found">Post not found.</div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="blog-post-page">
        <nav className="blog-nav">
          <button className="blog-nav-back" onClick={() => navigate('/blog')}>← Blog</button>
          <span className="blog-nav-logo display-font">World Cup Pick'em</span>
        </nav>
        <div className="blog-post-content blog-loading">Loading…</div>
      </div>
    );
  }

  return (
    <div className="blog-post-page">
      <nav className="blog-nav">
        <button className="blog-nav-back" onClick={() => navigate('/blog')}>← Blog</button>
        <span className="blog-nav-logo display-font">World Cup Pick'em</span>
      </nav>

      <article className="blog-post-content">
        <div className="blog-post-date">{formatDate(post.publishedAt)}</div>
        <h1 className="blog-post-title display-font">{post.title}</h1>
        <div className="blog-post-body">
          <ReactMarkdown>{post.body}</ReactMarkdown>
        </div>
      </article>

      <footer className="blog-footer">
        <span className="blog-footer-copy">© 2026 World Cup Pick'em</span>
        <div className="blog-footer-links">
          <button className="blog-footer-link" onClick={() => navigate('/terms')}>Terms of Service</button>
          <span>·</span>
          <button className="blog-footer-link" onClick={() => navigate('/privacy')}>Privacy Policy</button>
        </div>
      </footer>
    </div>
  );
}
